import { render, staticRenderFns } from "./BaseRetail.vue?vue&type=template&id=39689b30"
import script from "./BaseRetail.vue?vue&type=script&lang=js"
export * from "./BaseRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports